const WHATSAPP_URL = 'https://wa.me/923179699957?text=Hi%20Moin%20Khan%20Boxing%20Academy!%20I%20want%20to%20join%20training';

export default function WhatsAppStickyButton() {
  return (
    <a
      href={WHATSAPP_URL}
      target="_blank"
      rel="noopener noreferrer"
      className="fixed bottom-6 right-6 z-50 w-14 h-14 md:w-16 md:h-16 bg-[#25D366] rounded-full flex items-center justify-center shadow-lg shadow-black/50 animate-pulse-slow hover:scale-110 transition-transform duration-300 cursor-pointer"
      aria-label="Chat on WhatsApp"
    >
      <span className="w-8 h-8 flex items-center justify-center">
        <i className="ri-whatsapp-line text-white text-2xl" />
      </span>
    </a>
  );
}